
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/accessibility",
      function () {
        return require("private-next-pages/g/accessibility.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/accessibility"])
      });
    }
  